import { AccessToken, AccessTokenResult } from '~/Api/Authentication';
import { PasswordLoginResult } from '~/Api/Authentication/Password';

export enum ActionType {
	request = 'AccessToken.request',
	receive = 'AccessToken.receive',
	requestLogin = 'AccessToken.requestLogin',
	receiveLogin = 'AccessToken.receiveLogin',
	logout = 'AccessToken.logout',
}

export interface RequestAction {
	request: Promise<AccessTokenResult>;
	type: ActionType.request;
}

export interface ReceiveAction {
	accessToken: AccessToken | null;
	request: Promise<AccessTokenResult>;
	type: ActionType.receive;
	userChanged: boolean;
}

export interface RequestLogin {
	request: Promise<PasswordLoginResult>;
	type: ActionType.requestLogin;
}

export interface ReceiveLogin {
	accessToken: AccessToken | null;
	request: Promise<PasswordLoginResult>;
	type: ActionType.receiveLogin;
}

export interface LogoutAction {
	type: ActionType.logout;
}

export type Action = RequestAction | ReceiveAction | RequestLogin | ReceiveLogin | LogoutAction;
export type AccessTokenAction = Action;
